export default "__VITE_ASSET__DGESrBAQ__"